import axios from "axios";
import { Toast } from "../../util/Toast";
import {
    CLOSE_ADMIN_DIALOG,
    CREATE_ADMIN,
    DELETE_ADMIN,
    GET_ADMINS,
    UPDATE_ADMIN,
    TOGGLE_ADMIN_DISABLED,
} from "./types";

export const getAdmins = () => (dispatch) => {
    axios
        .get(`admin/all`)
        .then((res) => {
            if (res.data.status) {
                dispatch({ type: GET_ADMINS, payload: res.data.admins });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

// Resolves with { username, temporaryPassword, expiresAt } so the dialog can
// show the temporary password once; resolves with null on failure.
export const createAdmin = (data) => (dispatch) =>
    axios
        .post(`admin`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Admin created successfully!");
                dispatch({ type: CREATE_ADMIN, payload: res.data.admin });
                return res.data;
            }
            Toast("error", res.data.message);
            return null;
        })
        .catch((error) => {
            Toast("error", error.message);
            return null;
        });

// Issues a new temporary password: the admin must set a new password and
// register a new authenticator at their next sign-in.
// `username` is only needed for admins that do not have one yet (Lark-era accounts).
export const resetAdminSignin = (adminId, username) => () =>
    axios
        .post(`admin/${adminId}/reset-signin`, username ? { username } : {})
        .then((res) => {
            if (res.data.status) return res.data;
            Toast("error", res.data.message);
            return null;
        })
        .catch((error) => {
            Toast("error", error.message);
            return null;
        });

export const updateAdmin = (adminId, data) => (dispatch) => {
    axios
        .patch(`admin/${adminId}`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Admin updated successfully!");
                dispatch({ type: CLOSE_ADMIN_DIALOG });
                dispatch({
                    type: UPDATE_ADMIN,
                    payload: { data: res.data.admin, id: adminId },
                });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

export const deleteAdmin = (adminId) => (dispatch) => {
    axios
        .delete(`admin/${adminId}`)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Admin deleted successfully!");
                dispatch({ type: DELETE_ADMIN, payload: adminId });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

export const toggleAdminDisabled = (adminId) => (dispatch) => {
    axios
        .post(`admin/${adminId}/toggle-disabled`)
        .then((res) => {
            if (res.data.status) {
                Toast("success", res.data.message);
                dispatch({
                    type: TOGGLE_ADMIN_DISABLED,
                    payload: { data: res.data.admin, id: adminId },
                });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

export const updateLarkNotifications = (adminId, notificationTypes) => (dispatch) => {
    axios
        .put(`admin/${adminId}/lark-notifications`, { notificationTypes })
        .then((res) => {
            if (res.data.status) {
                Toast("success", res.data.message);
                dispatch({
                    type: UPDATE_ADMIN,
                    payload: { data: res.data.admin, id: adminId },
                });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};
